// @ts-nocheck
import { useDisclosure } from "@chakra-ui/react";
import React from "react";
import {
  HashRouter,
  Route,
  StaticRouter,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

const isServer = typeof window === "undefined";

export const OverlayRoute = ({ path, children, exact = true }) => {
  return (
    <Route
      path={path}
      exact={exact}
      render={(props) => <>{React.cloneElement(children, { ...props })}</>}
    />
  );
};
export const OverlaySwitch = ({ children }) => {
  return <Switch>{children}</Switch>;
};
export const OverlayRouter = ({ children }) => {
  const Router = isServer ? StaticRouter : HashRouter;
  return (
    <Router>
      <Switch>
        <Route
          path="/"
          render={({ staticContext, ...props }) => {
            return React.cloneElement(children, props);
          }}
        />
      </Switch>
    </Router>
  );
};

export const OverlayWrapper = ({
  children,
  path,
  exact,
}: {
  path?: any;
  exact?: any;
  children: any;
}) => {
  if (path) {
    return (
      <OverlayRoute path={path} exact={exact}>
        {children}
      </OverlayRoute>
    );
  }
  return children;
};

export const useOverlayDisclosure = (
  path?: string,
): {
  isOpen: boolean;
  onClose: (customPath?: string) => void;
  onOpen: (customPath?: string) => void;
  onToggle: (customPath?: string) => void;
  rawClose: () => void;
  rawOpen: (customPath?: string) => void;
} => {
  let [pathName, setPathName] = React.useState("");
  let location = useLocation();
  let history = useHistory();
  let { isOpen, onClose, onOpen } = useDisclosure();

  function rawOpen(customPath = "") {
    let _path = customPath || path;
    setPathName(_path);
    if (_path) {
      history.push(_path);
    }
    onOpen();
  }

  function rawClose() {
    onClose();
    if (path || pathName) {
      history.goBack();
    }
  }

  function overrideOnOpen(customPath = "") {
    let _path = customPath || path;
    if (pathName !== _path) {
      setPathName(_path);
      window.location.hash = `#${_path}`;
      onOpen();
    } else {
      window.location.hash = `#${_path}`;
      onOpen();
    }
    if (!isOpen) {
      window.location.hash = `#${_path}`;
      onOpen();
    }

    // if (_path) {
    //   history.push(_path);
    // }
  }
  function overrideOnClose() {
    let v = path;
    if (v) {
      let hash = window.location.hash.split("#")[1];
      if (hash === v) {
        setPathName("");
        onClose();
        window.history.replaceState(null, null, "#/");
        // window.location.hash = `#/`;
      } else {
        if (isOpen) {
          onClose();
        }
      }
      // history.goBack();
    } else {
      onClose();
    }
  }

  return {
    isOpen,
    onClose: overrideOnClose,
    onOpen: overrideOnOpen,
    onToggle: isOpen ? overrideOnClose : overrideOnOpen,
    rawClose,
    rawOpen,
  };
};

export const useOverlayHook = (path) => {
  let location = useLocation();
  let match = useRouteMatch(path);

  return [location, match];
};
